module.exports = __webpack_public_path__ + "static/img/41_paint.596a0114.jpg";